import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../css/HeaderMenu.css";
import { Icon } from "@mui/material";

export default function HeaderMenu({ name, position }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentTime, setCurrentTime] = useState("");
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      localStorage.clear();
      navigate("/signin");
    } catch (error) {
      alert("Logout Gagal", "Terjadi kesalahan saat logout.");
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const closeDropdown = () => {
    if (showDropdown) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      const dateString = now.toLocaleDateString("id-ID", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
      setCurrentTime(`${dateString} `);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="header-menu-container" onClick={closeDropdown}>
      <div className="header">
        <div className="content-wrapper">
          <div className="left-container">
            <div className="name-text" title={name}>
              Halo, {name}!
            </div>
            <div className="position-text">{position}</div>
          </div>

          <button
            className="profile-button"
            onClick={() => navigate("/profil-menu")}
          >
            <Icon className="profile-icon">person</Icon>
          </button>
        </div>
      </div>

      {showDropdown && (
        <div className="dropdown-menu">
          <button
            className="dropdown-item"
            onClick={() => navigate("/profil-menu")}
          >
            Profil
          </button>
          <button className="dropdown-item" onClick={handleLogout}>
            Logout
          </button>
        </div>
      )}
    </div>
  );
}
